import React, { useState } from "react";
import { useBoxFiltros, useBox } from "../Helper/useBox";
import { GetKey } from "../Actions/GetContainer";
import request from "../../../Helpers/API";
import { GetFechas } from "../Helper/GetFechas";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import { BoxFiltros2 } from "../Helper/BoxFiltros2";
import { LoaderScreen } from "../../components/LoaderScreen";
import Swal from "sweetalert2";
import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { GetMonthNameByNumber } from "../Helper/GetMonthNameByNumber";
import { FiltroVentas } from "../Helper/FiltroVentas";

export const LineaVenta = () => {
  const fechaActual = new Date();
  const ejercicioActual = fechaActual.getFullYear();
  const mesActual = fechaActual.getMonth() + 1;
  const history = useHistory();
  const location = useLocation();
  const storedState = JSON.parse(localStorage.getItem('dashboard_filtro')) || {};
  const permisos = location.state;
   const idSucursalUnicos = [
  ...new Map(permisos.map(item => [item.idsucursal, { idsucursal: item.idsucursal }])).values()
  ];
  const onHome = () => {
    history.push("/Finanzas/Main")
  };
  const [state, setState] = useState({
    subtitulo: "",
    data: [],
  });

  const [titulo, setTitulo] = useState('VENTAS NETAS');
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
   const [boxstate, setBoxState] = useBox({
      ejercicio: storedState.ejercicio || ejercicioActual,
      mesInicio: storedState.periodoinicio || 1,
      mesFin: storedState.periodofin || mesActual,
      ejercicioinicio: storedState.ejercicio || ejercicioActual,
      periodoinicio: storedState.periodoinicio || "1",
      ejerciciofin: storedState.ejercicio || ejercicioActual,
      periodofin: storedState.periodofin || mesActual,
      arraysucursal: [],
      arraydepartamento: [],
      pv: { adr: [], sucursal: [], departamento: [] },
      visualizacion: "1"
    }
    );


  const cargarDatosIniciales = async () => {
    setLoader({ ...loader, mostrar: true });
    const fechaActual = new Date();
    const ejercicioActual = fechaActual.getFullYear();
    const mesActual = fechaActual.getMonth() + 1;

    const ejercicioInicio = boxstate.ejercicio || ejercicioActual.toString();
    const periodoInicio = boxstate.periodoinicio || "1";
    const ejercicioFin = boxstate.ejercicio || ejercicioActual.toString();
    const periodoFin = boxstate.periodofin || mesActual.toString();

    // const nuevoBoxState = {
    //   ...boxstate,
    //   ejercicioinicio: ejercicioInicio,
    //   periodoinicio: periodoInicio,
    //   ejerciciofin: ejercicioFin,
    //   periodofin: periodoFin,
    // };

    // setBoxState(nuevoBoxState);

    const post = {
      EjercicioInicio: ejercicioInicio,
      PeriodoInicio: periodoInicio,
      EjercicioFin: ejercicioFin,
      PeriodoFin: periodoFin,
      adr: GetKey(boxstate.pv.adr, ["idadr"]),
      sucursales: GetKey(boxstate.pv.sucursal, ["idsucursal"]) || GetKey(idSucursalUnicos, ["idsucursal"]),
    };
    const getMonthName = (monthNumber) => {
      const months = [
        "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
        "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
      ];
      return months[monthNumber - 1];
    };

    const subtitulo = `De ${getMonthName(periodoInicio)} ${ejercicioInicio} a ${getMonthName(periodoFin)} ${ejercicioFin}`;

    try {
      const result = await request.post("FELineaNegocio/GetEsquemaByLineadeNegocio", post);
      setState((prevState) => ({
        ...prevState,
        data: result,
        subtitulo: subtitulo,
      }));
    } catch (err) {
      console.error(err);
    } finally {
      setLoader((prevLoader) => ({ ...prevLoader, mostrar: false }));
      setState((prevState) => ({
        ...prevState,
        subtitulo: subtitulo,
      }));
      if (
        String(boxstate.periodoinicio) === String(boxstate.periodofin) &&
        String(boxstate.ejercicioinicio) === String(boxstate.ejerciciofin)
      ) {
        setTitulo(
          `VENTAS NETAS ${GetMonthNameByNumber(boxstate.periodoinicio).toUpperCase()} ${boxstate.ejercicioinicio}`
        );
      } else {
        setTitulo(
          `VENTAS NETAS ${GetMonthNameByNumber(boxstate.periodoinicio).toUpperCase()} ${boxstate.ejercicioinicio} - ${GetMonthNameByNumber(boxstate.periodofin).toUpperCase()} ${boxstate.ejerciciofin}`
        );
      }
    }
  };

  useEffect(() => {
    cargarDatosIniciales();
  }, []);

  const handdleBoxClick = () => {
    return new Promise((res, req) => {
      setLoader({ ...loader, mostrar: true });
      if (
        boxstate.ejercicioinicio === undefined ||
        boxstate.ejercicioinicio === null ||
        boxstate.ejercicioinicio === "" ||
        boxstate.ejercicioinicio === "0" ||
        boxstate.ejercicioinicio === 0
      ) {
        req("Favor de agregar el ejercicio de inicio");
        setLoader({ ...loader, mostrar: false });
        return;
      }
      if (
        boxstate.periodoinicio === undefined ||
        boxstate.periodoinicio === null ||
        boxstate.periodoinicio === "" ||
        boxstate.periodoinicio === "0" ||
        boxstate.periodoinicio === 0
      ) {
        req("Favor de agregar el periodo de inicio");
        setLoader({ ...loader, mostrar: false });
        return;
      }
      if (
        boxstate.ejerciciofin === undefined ||
        boxstate.ejerciciofin === null ||
        boxstate.ejerciciofin === "" ||
        boxstate.ejerciciofin === "0" ||
        boxstate.ejerciciofin === 0
      ) {
        req("Favor de agregar el ejercicio fin");
        setLoader({ ...loader, mostrar: false });
        return;
      } else if (
        Number(boxstate.ejercicioinicio) > Number(boxstate.ejerciciofin)
      ) {
        req("El ejercicio de inicio debe ser menor o igual al ejercicio final");
        setLoader({ ...loader, mostrar: false });
        return;
      }
      if (boxstate.periodofin === undefined ||
        boxstate.periodofin === null ||
        boxstate.periodofin === '' ||
        boxstate.periodofin === "0" ||
        boxstate.periodofin === 0) {
        req("Favor de indicar el periodo final");
        setLoader({ ...loader, mostrar: false });

        return;
      } else if (
        Number(boxstate.ejercicioinicio) === Number(boxstate.ejerciciofin) &&
        Number(boxstate.periodoinicio) > Number(boxstate.periodofin)
      ) {
        req("El periodo de inicio no puede ser mayor a l periodo fin");
        setLoader({ ...loader, mostrar: false });

        return;
      }

      const post = {
        EjercicioInicio: Number(boxstate.ejercicioinicio),
        PeriodoInicio: Number(boxstate.periodoinicio),
        EjercicioFin: Number(boxstate.ejerciciofin),
        PeriodoFin: Number(boxstate.periodofin),
        adr: GetKey(boxstate.pv.adr, ["idadr"]),
        sucursales: GetKey(boxstate.pv.sucursal, ["idsucursal"]) || GetKey(idSucursalUnicos, ["idsucursal"]),
      };
      request
        .post("FELineaNegocio/GetEsquemaByLineadeNegocio", post)
        .then((result) => {
          res("Consulta realizada con exito");
          setLoader({ ...loader, mostrar: false });
          setState({
            ...state,
            data: result,
            subtitulo: GetFechas(boxstate),
          });
          if (
            String(boxstate.periodoinicio) === String(boxstate.periodofin) &&
            String(boxstate.ejercicioinicio) === String(boxstate.ejerciciofin)
          ) {
            setTitulo(
              `VENTAS NETAS ${GetMonthNameByNumber(boxstate.periodoinicio).toUpperCase()} ${boxstate.ejercicioinicio}`
            );
          } else {
            setTitulo(
              `VENTAS NETAS ${GetMonthNameByNumber(boxstate.periodoinicio).toUpperCase()} ${boxstate.ejercicioinicio} - ${GetMonthNameByNumber(boxstate.periodofin).toUpperCase()} ${boxstate.ejerciciofin}`
            );
          }
        })
        .catch((err) => req(err));
    });
  };

  const imprimirexcel = () => {
    if (boxstate.ejercicioinicio === "0") {
      alert("Favor de agregar el ejercicio de inicio");
      return;
    }
    if (boxstate.periodoinicio === "0") {
      alert("Favor de agregar el periodo de inicio");
      return;
    }
    if (boxstate.ejerciciofin === "0") {
      alert("Favor de agregar el ejercicio fin");
      return;
    } else if (
      Number(boxstate.ejercicioinicio) > Number(boxstate.ejerciciofin)
    ) {
      alert("El ejercicio de inicio debe ser menor o igual al ejercicio final");
      return;
    }
    if (boxstate.periodofin === "0") {
      alert("Favor de indicar el periodo final");
      return;
    } else if (
      Number(boxstate.ejercicioinicio) === Number(boxstate.ejerciciofin) &&
      Number(boxstate.periodoinicio) > Number(boxstate.periodofin)
    ) {
      alert("El periodo de inicio no puede ser mayor a l periodo fin");
      return;
    }

    const post = {
      EjercicioInicio: Number(boxstate.ejercicioinicio),
      PeriodoInicio: Number(boxstate.periodoinicio),
      EjercicioFin: Number(boxstate.ejerciciofin),
      PeriodoFin: Number(boxstate.periodofin),
      adr: GetKey(boxstate.pv.adr, ["idadr"]),
      sucursales: GetKey(boxstate.pv.sucursal, ["idsucursal"]) || GetKey(permisos, ["idsucursal"]),
    };
    request
      .post("FELineaNegocio/GetEsquemaByLineadeNegocioExcel", post)
      .then(({ documento, filename }) => {
        const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${filename}.xlsx`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((err) => console.log(err));
  };
  const SemaforoGastos = (item, valor) => {
    if (
      state.data.estadoresultados !== undefined &&
      state.data.estadoresultados !== null &&
      state.data.estadoresultados.length > 0
    ) {
      const utilidad = state.data.estadoresultados.filter(
        (x) => x.concepto === "(=) UTILIDAD BRUTA"
      );
      if (utilidad !== undefined && utilidad !== null && utilidad.length > 0) {
        const margen = utilidad[0][item];
        const semaforo = Number(margen) / Number(valor);
        if (semaforo >= 3) return "semaforo-verde";
        else if (semaforo >= 2 && semaforo < 3) return "semaforo-advertencia";
        else return "semaforo-peligro";
      }
    }
    return "";
  };
  const PDFDownloadButton = () => {
    setLoader({ ...loader, mostrar: true });
    const post = {
      subtitulo: state.subtitulo,
      data: state.data,
      region: boxstate.pv.adr,
      sucursal: boxstate.pv.sucursal
    }
    request
      .post(`FELineaNegocio/ReportePDF`, post)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        const linkSource = `data:application/pdf;base64, ${result.documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${result.nombredocumento}.${result.extension}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("ESTADO DE RESULTADOS", JSON.stringify(error), "error");
      });
  };

  const onGeneraExcel = () => {
    setLoader({ ...loader, mostrar: true });
    const post = {
      subtitulo: state.subtitulo,
      data: state.data,
      region: boxstate.pv.adr,
      sucursal: boxstate.pv.sucursal
    }
    request
      .post("FELineaNegocio/GenerarExcel", post)
      .then(({ documento, filename }) => {
        const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${filename}.xlsx`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        setLoader({ ...loader, mostrar: false });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("CREDITO Y COBRANZA", JSON.stringify(error), "error");
      });
  }
  return (
    <PlantillaScreen
      titulo={titulo}
      className={"ventas-netas-main-screen"}
      className_main={1}
    >
      <div id="esquema-financiero">
        <div className="linea-negocio-screen-container-header">
          <LoaderScreen loader={loader} />
          <div className="ventas-netas-contenedor-filtros">
            <div className='ventas-netas-regresar'
              onClick={() => onHome()}
            >
              <ArrowBackIcon /> Regresar
            </div>
            <FiltroVentas
              boxState={boxstate}
              onBoxChange={setBoxState}
              BoxClick={handdleBoxClick}
              sucursales={permisos}
              // titulo="Resultados por Línea de Negocio"
              mostrardepartamento={false}
              // subtitulo={state.subtitulo}
              titulo_filtro="FILTRO"
            >
            </FiltroVentas>
          </div>
          {state.data.length < 1 ? <div></div> :
            <div className="linea-negocio-screen-botones-container">
              <button className="excel" onClick={() => onGeneraExcel()}>
                Excel
              </button>

              <button className="PDF" onClick={() => PDFDownloadButton()}>
                PDF
              </button>
            </div>
          }
        </div>
        {state.data.estadoresultados !== undefined &&
          state.data.estadoresultados !== null &&
          state.data.estadoresultados.length > 0 ? (
          <div className="esquema-financiero-container">
            <div className="esquema-financiero-container-table scroll">
              <table cellSpacing={0} id="tabla-fixed-blank">
                <tbody>
                  <tr>
                    <td
                      colSpan={7}
                      className="row-sticky-180 row-ventas-netas-totales"
                    >
                      <label>Ventas Netas Totales </label>
                      <span>
                        $ {FormatMoney(state.data.ventastotales.totalventas, 0)}
                      </span>
                      <label className="">Expresado en miles de pesos</label>
                    </td>
                    <td colSpan={20} className="row-ventas-netas-totales"></td>
                  </tr>
                  <tr>
                    <td rowSpan={3} className="row-sticky-180 bg-analisis">
                      Resultados por Línea de Negocio
                    </td>
                    <td colSpan={10} className="enc-jd">
                      Líneas John Deere
                    </td>
                    <td colSpan={10} className="enc-ol">
                      Líneas Aliadas
                    </td>
                    <td colSpan={2} className="enc-jd"></td>
                    <td colSpan={2} className="enc-header-gastos"></td>
                    <td colSpan={2} className="enc-ol"></td>
                  </tr>
                  <tr>
                    <td colSpan={6} className="enc-importe enc-importe-jd">
                      {FormatMoney(state.data.margenesbygrupo.lineasjd, 0)}
                    </td>
                    <td colSpan={4} className="enc-importe enc-importe-jd">
                      {FormatMoney(state.data.margenesbygrupo.mrglineasjd, 2)} %
                    </td>
                    <td colSpan={6} className="enc-importe enc-importe-ol">
                      {FormatMoney(state.data.margenesbygrupo.otraslineas, 0)}
                    </td>
                    <td colSpan={4} className="enc-importe enc-importe-ol">
                      {FormatMoney(state.data.margenesbygrupo.mrgotraslineas, 2)} %
                    </td>
                    <td colSpan={2} rowSpan={2} className="enc-sumajsol">
                      Suma JD + O.L
                    </td>
                    <td colSpan={2} rowSpan={2} className="enc-gastos">
                      Staff + Finanzas + Admon
                    </td>
                    <td colSpan={2} rowSpan={2} className="enc-total">
                      Total
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2} className="enc-texto enc-texto-jd">
                      Maquinaria
                    </td>
                    <td colSpan={2} className="enc-texto enc-texto-jd">
                      Soluciones Integrales
                    </td>
                    <td colSpan={2} className="enc-texto enc-texto-jd">
                      Refacciones
                    </td>
                    <td colSpan={2} className="enc-texto enc-texto-jd">
                      Servicio
                    </td>
                    <td colSpan={2} className="enc-texto enc-texto-jd">
                      Suma JD
                    </td>
                    <td colSpan={2} className="enc-texto enc-texto-ol">
                      Prod. Aliado
                    </td>
                    <td colSpan={2} className="enc-texto enc-texto-ol">
                      Ferretería
                    </td>
                    <td colSpan={2} className="enc-texto enc-texto-ol">
                      Riego
                    </td>
                    <td colSpan={2} className="enc-texto enc-texto-ol">
                      Seminuevos
                    </td>
                    <td colSpan={2} className="enc-texto enc-texto-ol">
                      Suma O.L.
                    </td>
                  </tr>
                  {state.data.estadoresultados.map((x) => (
                    <tr className="row">
                      <td
                        className={`row-sticky-180 ${x.concepto === "(=) UTILIDAD BRUTA" ||
                          x.concepto === "(=) UTILIDAD DE OPERACIÓN"
                          ? "fw-bold"
                          : ""
                          }`}
                      >
                        {x.concepto}
                      </td>
                      <td
                        className={`importe-ef ${x.concepto === "(=) UTILIDAD BRUTA" ||
                          x.concepto === "(=) UTILIDAD DE OPERACIÓN"
                          ? "fw-bold"
                          : ""
                          }`}
                      >
                        {FormatMoney(x.maquinaria, 0)}
                      </td>
                      <td
                        className={`margen-rf 
                                    ${x.concepto === "(=) UTILIDAD BRUTA" ||
                            x.concepto === "(=) UTILIDAD DE OPERACIÓN"
                            ? "fw-bold"
                            : ""
                          }
                                    ${x.concepto === "(-) GASTOS DE OPERACIÓN"
                            ? SemaforoGastos(
                              "mrgmaquinaria",
                              x.mrgmaquinaria
                            )
                            : ""
                          }
                                    `}
                      >
                        {FormatMoney(x.mrgmaquinaria, 2)} %
                      </td>
                      <td
                        className={`importe-ef ${x.concepto === "(=) UTILIDAD BRUTA" ||
                          x.concepto === "(=) UTILIDAD DE OPERACIÓN"
                          ? "fw-bold"
                          : ""
                          }                                            `}
                      >
                        {FormatMoney(x.ams, 0)}
                      </td>
                      <td
                        className={`margen-rf 
                                    ${x.concepto === "(=) UTILIDAD BRUTA" ||
                            x.concepto === "(=) UTILIDAD DE OPERACIÓN"
                            ? "fw-bold"
                            : ""
                          }
                                    ${x.concepto === "(-) GASTOS DE OPERACIÓN"
                            ? SemaforoGastos("mrgams", x.mrgams)
                            : ""
                          }
                                    `}
                      >
                        {FormatMoney(x.mrgams, 2)} %
                      </td>
                      <td
                        className={`importe-ef ${x.concepto === "(=) UTILIDAD BRUTA" ||
                          x.concepto === "(=) UTILIDAD DE OPERACIÓN"
                          ? "fw-bold"
                          : ""
                          }`}
                      >
                        {FormatMoney(x.refacciones, 0)}
                      </td>
                      <td
                        className={`margen-rf 
                                    ${x.concepto === "(=) UTILIDAD BRUTA" ||
                            x.concepto === "(=) UTILIDAD DE OPERACIÓN"
                            ? "fw-bold"
                            : ""
                          }
                                    ${x.concepto === "(-) GASTOS DE OPERACIÓN"
                            ? SemaforoGastos(
                              "mrgrefacciones",
                              x.mrgrefacciones
                            )
                            : ""
                          }
                                    `}
                      >
                        {FormatMoney(x.mrgrefacciones, 2)} %
                      </td>
                      <td
                        className={`importe-ef ${x.concepto === "(=) UTILIDAD BRUTA" ||
                          x.concepto === "(=) UTILIDAD DE OPERACIÓN"
                          ? "fw-bold"
                          : ""
                          }`}
                      >
                        {FormatMoney(x.servicio, 0)}
                      </td>
                      <td
                        className={`margen-rf 
                                    ${x.concepto === "(=) UTILIDAD BRUTA" ||
                            x.concepto === "(=) UTILIDAD DE OPERACIÓN"
                            ? "fw-bold"
                            : ""
                          }
                                    ${x.concepto === "(-) GASTOS DE OPERACIÓN"
                            ? SemaforoGastos(
                              "mrgservicio",
                              x.mrgservicio
                            )
                            : ""
                          }
                                    `}
                      >
                        {FormatMoney(x.mrgservicio, 2)} %
                      </td>
                      <td
                        className={`importe-ef ${x.concepto === "(=) UTILIDAD BRUTA" ||
                          x.concepto === "(=) UTILIDAD DE OPERACIÓN"
                          ? "fw-bold"
                          : ""
                          }`}
                      >
                        {FormatMoney(x.sumajs, 0)}
                      </td>
                      <td
                        className={`margen-rf 
                                    ${x.concepto === "(=) UTILIDAD BRUTA" ||
                            x.concepto === "(=) UTILIDAD DE OPERACIÓN"
                            ? "fw-bold"
                            : ""
                          }
                                    ${x.concepto === "(-) GASTOS DE OPERACIÓN"
                            ? SemaforoGastos(
                              "mrgsumajd",
                              x.mrgsumajd
                            )
                            : ""
                          }
                                    `}
                      >
                        {FormatMoney(x.mrgsumajd, 2)} %
                      </td>
                      <td
                        className={`importe-ef ${x.concepto === "(=) UTILIDAD BRUTA" ||
                          x.concepto === "(=) UTILIDAD DE OPERACIÓN"
                          ? "fw-bold"
                          : ""
                          }`}
                      >
                        {FormatMoney(x.paliados, 0)}
                      </td>
                      <td
                        className={`margen-rf 
                                ${x.concepto === "(=) UTILIDAD BRUTA" ||
                            x.concepto === "(=) UTILIDAD DE OPERACIÓN"
                            ? "fw-bold"
                            : ""
                          }
                                ${x.concepto === "(-) GASTOS DE OPERACIÓN"
                            ? SemaforoGastos(
                              "mrgpaliados",
                              x.mrgpaliados
                            )
                            : ""
                          }
                                `}
                      >
                        {FormatMoney(x.mrgpaliados, 2)} %
                      </td>
                      <td
                        className={`importe-ef ${x.concepto === "(=) UTILIDAD BRUTA" ||
                          x.concepto === "(=) UTILIDAD DE OPERACIÓN"
                          ? "fw-bold"
                          : ""
                          }`}
                      >
                        {FormatMoney(x.ferreteria, 0)}
                      </td>
                      <td
                        className={`margen-rf 
                                ${x.concepto === "(=) UTILIDAD BRUTA" ||
                            x.concepto === "(=) UTILIDAD DE OPERACIÓN"
                            ? "fw-bold"
                            : ""
                          }
                                ${x.concepto === "(-) GASTOS DE OPERACIÓN"
                            ? SemaforoGastos(
                              "mrgferreteria",
                              x.mrgferreteria
                            )
                            : ""
                          }
                                `}
                      >
                        {FormatMoney(x.mrgferreteria, 2)} %
                      </td>
                      <td
                        className={`importe-ef ${x.concepto === "(=) UTILIDAD BRUTA" ||
                          x.concepto === "(=) UTILIDAD DE OPERACIÓN"
                          ? "fw-bold"
                          : ""
                          }`}
                      >
                        {FormatMoney(x.sriego, 0)}
                      </td>
                      <td
                        className={`margen-rf 
                                ${x.concepto === "(=) UTILIDAD BRUTA" ||
                            x.concepto === "(=) UTILIDAD DE OPERACIÓN"
                            ? "fw-bold"
                            : ""
                          }
                                ${x.concepto === "(-) GASTOS DE OPERACIÓN"
                            ? SemaforoGastos("mrgsriego", x.mrgsriego)
                            : ""
                          }
                                `}
                      >
                        {FormatMoney(x.mrgsriego, 2)} %
                      </td>
                      <td
                        className={`importe-ef ${x.concepto === "(=) UTILIDAD BRUTA" ||
                          x.concepto === "(=) UTILIDAD DE OPERACIÓN"
                          ? "fw-bold"
                          : ""
                          }`}
                      >
                        {FormatMoney(x.usados, 0)}
                      </td>
                      <td
                        className={`margen-rf 
                                ${x.concepto === "(=) UTILIDAD BRUTA" ||
                            x.concepto === "(=) UTILIDAD DE OPERACIÓN"
                            ? "fw-bold"
                            : ""
                          }
                                ${x.concepto === "(-) GASTOS DE OPERACIÓN"
                            ? SemaforoGastos("mrgusados", x.mrgusados)
                            : ""
                          }
                                `}
                      >
                        {FormatMoney(x.mrgusados, 2)} %
                      </td>
                      <td
                        className={`importe-ef ${x.concepto === "(=) UTILIDAD BRUTA" ||
                          x.concepto === "(=) UTILIDAD DE OPERACIÓN"
                          ? "fw-bold"
                          : ""
                          }`}
                      >
                        {FormatMoney(x.sumaol, 0)}
                      </td>
                      <td
                        className={`margen-rf 
                                ${x.concepto === "(=) UTILIDAD BRUTA" ||
                            x.concepto === "(=) UTILIDAD DE OPERACIÓN"
                            ? "fw-bold"
                            : ""
                          }
                                ${x.concepto === "(-) GASTOS DE OPERACIÓN"
                            ? SemaforoGastos("mrgsumaol", x.mrgsumaol)
                            : ""
                          }
                                `}
                      >
                        {FormatMoney(x.mrgsumaol, 2)} %
                      </td>
                      <td
                        className={`importe-ef ${x.concepto === "(=) UTILIDAD BRUTA" ||
                          x.concepto === "(=) UTILIDAD DE OPERACIÓN"
                          ? "fw-bold"
                          : ""
                          }`}
                      >
                        {FormatMoney(x.sumamh, 0)}
                      </td>
                      <td
                        className={`margen-rf 
                                ${x.concepto === "(=) UTILIDAD BRUTA" ||
                            x.concepto === "(=) UTILIDAD DE OPERACIÓN"
                            ? "fw-bold"
                            : ""
                          }
                                ${x.concepto === "(-) GASTOS DE OPERACIÓN"
                            ? SemaforoGastos("mrgsumamh", x.mrgsumamh)
                            : ""
                          }
                                `}
                      >
                        {FormatMoney(x.mrgsumamh, 2)} %
                      </td>
                      <td
                        className={`importe-ef ${x.concepto === "(=) UTILIDAD BRUTA" ||
                          x.concepto === "(=) UTILIDAD DE OPERACIÓN"
                          ? "fw-bold"
                          : ""
                          }`}
                      >
                        {FormatMoney(x.gastos, 0)}
                      </td>
                      <td
                        className={`margen-rf 
                                ${x.concepto === "(=) UTILIDAD BRUTA" ||
                            x.concepto === "(=) UTILIDAD DE OPERACIÓN"
                            ? "fw-bold"
                            : ""
                          }
                                `}
                      >
                        {FormatMoney(x.mrggastos, 2)} %
                      </td>
                      <td
                        className={`importe-ef ${x.concepto === "(=) UTILIDAD BRUTA" ||
                          x.concepto === "(=) UTILIDAD DE OPERACIÓN"
                          ? "fw-bold"
                          : ""
                          }`}
                      >
                        {FormatMoney(x.sumatotal, 0)}
                      </td>
                      <td
                        className={`margen-rf 
                                        ${x.concepto === "(=) UTILIDAD BRUTA" ||
                            x.concepto ===
                            "(=) UTILIDAD DE OPERACIÓN"
                            ? "fw-bold"
                            : ""
                          }
                                        ${x.concepto ===
                            "(=) UTILIDAD DE OPERACIÓN"
                            ? "noros"
                            : ""
                          }
                                        ${x.concepto ===
                            "(-) GASTOS DE OPERACIÓN"
                            ? SemaforoGastos(
                              "mrgsumatotal",
                              x.mrgsumatotal
                            )
                            : ""
                          }
                                        `}
                      >
                        {FormatMoney(x.mrgsumatotal, 2)} %
                        {x.concepto === "(=) UTILIDAD DE OPERACIÓN" ? (
                          <>
                            <div
                              className={`tip-noros ${x.mrgsumatotal >= 7
                                ? "semaforo-verde"
                                : x.mrgsumatotal >= 6 && x.mrgsumatotal < 7
                                  ? "semaforo-advertencia"
                                  : "semaforo-peligro"
                                }`}
                            >
                              Noros
                            </div>
                            <div className="line-top-noros"></div>
                            <div className="line-bottom-noros"></div>
                          </>
                        ) : (
                          <></>
                        )}
                      </td>
                    </tr>
                  ))}

                  <tr className="row-espacio"></tr>
                  <tr>
                    <td colSpan={7} className="row-sticky-180 sub-menu">
                      Indicadores
                    </td>
                    <td colSpan={20} className="enc-jd sub-menu"></td>
                  </tr>
                  <tr className="row">
                    <td className="row-sticky-180">MARGEN</td>
                    <td colSpan={2} className="margen-rf">
                      {FormatMoney(state.data.indicadores.mrgmaquinaria, 2)} %
                    </td>
                    <td colSpan={2} className="margen-rf">
                      {FormatMoney(state.data.indicadores.mrgams, 2)} %
                    </td>
                    <td colSpan={2} className="margen-rf">
                      {FormatMoney(state.data.indicadores.mrgrefacciones, 2)} %
                    </td>
                    <td colSpan={2} className="margen-rf">
                      {FormatMoney(state.data.indicadores.mrgservicio, 2)} %
                    </td>
                    <td colSpan={2} className="margen-rf">
                      {FormatMoney(state.data.indicadores.mrgsumajd, 2)} %
                    </td>
                    <td colSpan={2} className="margen-rf">
                      {FormatMoney(state.data.indicadores.mrgpaliados, 2)} %
                    </td>
                    <td colSpan={2} className="margen-rf">
                      {FormatMoney(state.data.indicadores.mrgferreteria, 2)} %
                    </td>
                    <td colSpan={2} className="margen-rf">
                      {FormatMoney(state.data.indicadores.mrgsriego, 2)} %
                    </td>
                    <td colSpan={2} className="margen-rf">
                      {FormatMoney(state.data.indicadores.mrgusados, 2)} %
                    </td>
                    <td colSpan={2} className="margen-rf">
                      {FormatMoney(state.data.indicadores.mrgsumaol, 2)} %
                    </td>
                    <td colSpan={2} className="margen-rf">
                      {FormatMoney(state.data.indicadores.mrgsumatotal, 2)} %
                    </td>
                  </tr>
                  <tr className="row">
                    <td className="row-sticky-180">VENTAS / VENTAS TOTALES</td>
                    <td colSpan={2} className="margen-rf">
                      {FormatMoney(state.data.margenventasnetas.maquinaria, 2)} %
                    </td>
                    <td colSpan={2} className="margen-rf">
                      {FormatMoney(state.data.margenventasnetas.ams, 2)} %
                    </td>
                    <td colSpan={2} className="margen-rf">
                      {FormatMoney(state.data.margenventasnetas.refacciones, 2)} %
                    </td>
                    <td colSpan={2} className="margen-rf">
                      {FormatMoney(state.data.margenventasnetas.servicio, 2)} %
                    </td>
                    <td colSpan={2} className="margen-rf">
                      {FormatMoney(state.data.margenventasnetas.jd, 2)} %
                    </td>
                    <td colSpan={2} className="margen-rf">
                      {FormatMoney(state.data.margenventasnetas.paliados, 2)} %
                    </td>
                    <td colSpan={2} className="margen-rf">
                      {FormatMoney(state.data.margenventasnetas.ferreteria, 2)} %
                    </td>
                    <td colSpan={2} className="margen-rf">
                      {FormatMoney(state.data.margenventasnetas.sriego, 2)} %
                    </td>
                    <td colSpan={2} className="margen-rf">
                      {FormatMoney(state.data.margenventasnetas.usados, 2)} %
                    </td>
                    <td colSpan={2} className="margen-rf">
                      {FormatMoney(state.data.margenventasnetas.ol, 2)} %
                    </td>
                    <td colSpan={2} className="margen-rf">
                      {FormatMoney(state.data.margenventasnetas.total, 2)} %
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    </PlantillaScreen>
  );
};
